export const APP_CONFIG = {
  // Default matches production: use hosted admin-api on Render when no env is set (no local server required).
  ADMIN_API_BASE_URL:
    process.env.REACT_APP_ADMIN_API_BASE_URL || "https://smart-farming-glkc.onrender.com/api",
};

export const USER_ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  OPERATOR: "operator",
  VIEWER: "viewer",
};

